import React from 'react'
import { Typography, Stack, Divider } from '@mui/material';

export default function AboutCompany({company}) {
  return (
    <Stack direction="row" sx={{
        flexDirection: {
            xs: 'column',
            md: 'row'
        },
        gap: {xs: 2, md: "60px"},
    }}>
        <Stack minWidth="20%" alignItems="flex-end" sx={{
            alignItems: {
                xs: 'flex-start',
                md: 'flex-end'
            }
        }}>
            <Typography fontSize="24px" fontWeight={600}>Om företaget</Typography>
        </Stack>

        <Stack flexGrow={1}>   

            <Stack gap={2}>
                
                {
                   company?.name && company?.name !== '' &&
                    <>
                        <Stack>
                            <Typography variant='subtitle' fontWeight={'bold'}>Namn</Typography>
                            <Typography>{company?.name}</Typography>
                        </Stack>

                        <Divider />
                    </>
                }

                {
                    company?.companyEmail && company?.companyEmail !== '' &&
                    <>
                        <Stack>
                            <Typography variant='subtitle' fontWeight={'bold'}>Email</Typography>
                            <Typography>{company?.companyEmail}</Typography>
                        </Stack>

                        <Divider />
                    </>
                }

                {
                    company?.companyPhone && company?.companyPhone !== '' &&
                    <>
                        <Stack>
                            <Typography variant='subtitle' fontWeight={'bold'}>Telefon</Typography>
                            <Typography>{company?.companyPhone}</Typography>
                        </Stack>

                        <Divider />
                    </>
                }


                {
                    company?.companyCountry && company?.companyCountry !== '' &&
                    <>
                        <Stack>
                            <Typography variant='subtitle' fontWeight={'bold'}>Land</Typography>
                            <Typography>{company?.companyCountry}</Typography>
                        </Stack>
                    </>
                }


                {
                    company?.companyDescription && company?.companyDescription !== '' &&

                    <>
                        <Divider />
                        <Stack>
                            <Typography variant='subtitle' fontWeight={'bold'}>Företagsbeskrivning</Typography>
                            <div className='company-description' dangerouslySetInnerHTML={{__html: company?.companyDescription}}></div>
                        </Stack>
                    </>
                }
                
                {
                    company?.companyIndustry && company?.companyIndustry !== '' &&
                    <>
                        <Divider />
                        <Stack>
                            <Typography variant='subtitle' fontWeight={'bold'}>Industri</Typography>
                            <Typography>{company?.companyIndustry}</Typography>
                        </Stack>
                    </>
                }
                

            </Stack>
        </Stack>
    </Stack>
  )
}
